import { requestNotif } from '@/_helpers/requests'

export const adminService = {
    encryptConnection() {
        return new Promise((resolve) => {
            requestNotif.post('admin/encryptconnection').then(response => {
                resolve({valid: response.status==200, message: response.data});
            });
        });
    },
    sendEmail(email) {
        return new Promise((resolve) => {
            requestNotif.post('admin/testemail', {Email: email}).then(response => {
                resolve(response.status == 200);
            });
        });
    },
    updateInfo() {
        return new Promise((resolve) => {
            requestNotif.get('update/info').then(response => {
                resolve(response.data);
            });
        });
    },
    loadLog() {
        return new Promise((resolve) => {
            requestNotif.get('admin/loadLog').then(response => {
                resolve({valid: response.status==200, message: response.data});
            });
        });
    },
    testLog() {
        return new Promise((resolve) => {
            requestNotif.post('admin/testLog').then(response => {
                resolve({valid: response.status==200, message: response.data});
            });
        });
    },
    descargarLog() {
        return new Promise((resolve) => {
            requestNotif.get('admin/descargarLog').then(response => {
                resolve({data: response.data, name: response.headers['x-file-name']});
            });
        });
    },
    emptyLog() {
        return new Promise((resolve) => {
            requestNotif.post('admin/emptyLog').then(response => {
                resolve({valid: response.status==200, message: response.data});
            });
        });
    },
    updLog(pathLog, logLevel) {
        return new Promise((resolve) => {
            requestNotif.post('admin/updLog/?path=' + pathLog +'&logLevel='+logLevel).then(response => {
                resolve({valid: response.status==200, message: response.data});
            });
        });
    },

    loadLogUpdator() {
        return new Promise((resolve) => {
            requestNotif.get('admin/loadLogUpdator').then(response => {
                resolve({valid: response.status==200, message: response.data});
            });
        });
    },

    updatePortal(action) {
        return new Promise((resolve) => {
            requestNotif.post('update/run?action=' + action).then(response =>{
                resolve(response);
            });
        });
    },

    testWSSmtpConfig() {
        return new Promise((resolve) => {
            requestNotif.post('admin/TestWSSmtpConfig').then(response => {
                resolve(response);
            });
        });
    },
    testWSOAuth() {
        return new Promise((resolve) => {
            requestNotif.post('admin/TestWSOAuth').then(response => {
                resolve(response);
            });
        });
    },
    testWS() {
        return new Promise((resolve) => {
            requestNotif.post('admin/testWS').then(response => {
                resolve(response);
            });
        });
    },
    testWSFusionDocs() {
        return new Promise((resolve) => {
            requestNotif.post('admin/testWSFusionDocs').then(response => {
                resolve(response);
            });
        });
    },
    testWSAnexo() {
        return new Promise((resolve) => {
            requestNotif.post('admin/testWSAnexo').then(response => {
                resolve(response);
            });
        });
    },
};